import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SubbotElementData } from '../../models';
import { AiConnectorDialogComponent } from './ai-connector-dialog/ai-connector-dialog.component';

@Component({
  selector: 'app-ai-connector',
  template: '',
})
export class AiConnectorComponent implements OnInit {
  @Input() elementData: SubbotElementData;
  @Output() cancelDialog = new EventEmitter();
  @Output() hideDialog = new EventEmitter<any>();

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    const dialogRef = this.dialog.open(AiConnectorDialogComponent, {
      data: this.elementData,
      disableClose: true,
      panelClass: 'quick-reply-medium-dialog',
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.hideDialog.emit({ type: 'ok', data });
      } else {
        this.cancelDialog.emit();
      }
    });
  }
}
